import styled from "styled-components";

import { PNG } from "@ryde/assets";
import {
  DATA_E2E_KEY,
  FORM_FIELD_ADDITIONAL_BUTTON_WIDTH,
  IStyledAttributes,
  LAYOUT_RIGHT_IMAGE_AREA_WIDTH,
} from "@ryde/shared";
import {
  blueGreyMui,
  deepPurpleMui,
  MOBILE_BREAKPOINT,
  rydeColors,
  ScreenDepth,
} from "@ryde/theme";

export const DrawerContentStyled = styled.section.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "drawer-content-styled",
})`
  flex: 1;
  overflow: auto;
  padding-inline-start: 24px;
  padding-inline-end: 0;
  padding-bottom: 48px;
  position: relative;

  .settings-search {
    position: sticky;
    top: 0;
    padding: 20px 0 5px;
    background: ${rydeColors.white};
  }

  .idLabelAdmin {
    margin-top: 16px;
    color: ${blueGreyMui._900};
    display: inline-block;
  }

  .fullWidth {
    width: 100%;
  }

  .bulk-update-notice-list {
    margin: 0;
    padding-inline-start: 20px;
  }

  &.produce-preview__content {
    padding-inline-end: 48px;
  }

  /* The bulk-actions panel owns its own top spacing and pins a sticky search at the very
     top of this scroll area, so it must start flush. */
  &.bulk-action-drawer {
    padding-top: 0;
  }
  &.related-entities-drawer-content {
    padding-inline-start: 8px;
    padding-inline-end: 8px;
    padding-top: 4px;
  }
  &.drawer-form {
    padding-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: stretch;
    // maximum two additional button for now
    padding-inline-end: calc(${FORM_FIELD_ADDITIONAL_BUTTON_WIDTH} * 2);
  }

  &.inner-item-editing-blur {
    .no-blur-item {
      position: relative;
      z-index: ${ScreenDepth.INNER_ITEM_EDIT};
    }
  }

  &.drawer-form-with-image {
    padding-inline-end: ${LAYOUT_RIGHT_IMAGE_AREA_WIDTH};
    background-image: url(${PNG.LayoutRightBg2PNG});
    background-repeat: no-repeat;
    background-position: bottom 0 right 25px;
    @media (max-width: ${MOBILE_BREAKPOINT}) {
      padding-inline-start: 10px;
      padding-inline-end: 10px;
      background-image: none;
      &.isAdmin {
        background-image: none;
      }
    }

    &.settings-drawer__container {
      min-height: 0;
    }

    &.settings-drawer__container,
    &.alert-edit-form {
      padding-inline-start: 0;
      background-image: url(${PNG.LayoutRightBg2PNG});
      &.isAdmin {
        background-image: url(${PNG.LayoutRightBgPNG});

        &.alert-edit-form {
          padding-inline-start: 24px;
        }
      }
      @media (max-width: ${MOBILE_BREAKPOINT}) {
        padding-inline-start: 10px;
        padding-inline-end: 10px;
        background-image: none;
        &.isAdmin {
          background-image: none;
        }
      }
    }
  }

  &.user-actions-history-drawer-content {
    padding-inline-start: 10px;
    padding-bottom: 0;
    padding-inline-end: 0;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding-inline-start: 10px;
    padding-inline-end: 10px;
    background-image: none;
  }
`;

export const ContentBlurOverlay = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "content-blur-overlay",
})`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${ScreenDepth.CONTENT_BLUR_OVERLAY};
  pointer-events: none;
  transition:
    backdrop-filter 0.55s ease-out,
    background 0.55s ease-out;

  &.active {
    backdrop-filter: blur(3px);
    background: rgba(255, 255, 255, 0.3);
  }
`;

export const DrawerContentWithImageStyled = styled(DrawerContentStyled)`
  padding-inline-end: ${LAYOUT_RIGHT_IMAGE_AREA_WIDTH};
  background-image: url(${PNG.LayoutRightBg2PNG});
  background-repeat: no-repeat;
  background-position: bottom 0 right 25px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding-inline-end: 10px;
    background-image: none;
  }
`;

export const PreCreationBlockContentWrapper = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "pre-creation-block-content",
  },
)`
  padding-top: 0;
  padding-inline-start: 24px;
  padding-inline-end: 0;
  padding-bottom: 20px;
  width: 100%;

  h3 {
    font-size: 16px;
    margin: 20px 0;

    &.bold {
      font-weight: 700;
      color: ${deepPurpleMui._300};
      text-align: center;
      margin-top: 40px;
    }
  }

  .link {
    margin-top: 20px;

    a {
      font-size: 16px;
      color: ${rydeColors.lightBlue};
      text-decoration: none;

      span {
        color: ${deepPurpleMui._300};
        margin-inline-start: 10px;
      }
    }
  }

  button {
    span {
      margin-inline-start: 10px;
    }
  }
  &.pre-creation-drawer__content {
    padding-inline-start: 0;
    padding-inline-end: 48px;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    &.pre-creation-drawer__content {
      padding-inline-end: 0;
    }
  }
`;
